module.exports = __webpack_public_path__ + "assets/favicons/apple-touch-icon-60x60.4f72c067f9b81a87f1d1658e59716dd1.png";